export default "__VITE_ASSET__1d21641d__"